import { useSelector } from 'react-redux';
import { PlaceEmployee } from '@/types/state/shared';
import { InstagramFeed, InstagramFeedSkeleton } from '@/components/modules/salon';
import { useEffect, useState } from 'react';
import { server } from '@/helpers/serverRequests';
import { classnames } from '@/helpers';
import Card from '@/components/elements/Card/Card';
import { _t } from '@/locale';

export const ReviewEmployeeSocials = ({
  employeeId,
  withCard,
  className,
}: {
  employeeId: number;
  withCard?: boolean;
  className?: string;
}) => {
  const employee = useSelector(
    (state: { employees: { all: Record<string, PlaceEmployee> } }) => state.employees.all[employeeId],
  );
  const instagramProfile = employee?.contact?.instagram;
  const [mediaFeed, setMediaFeed] = useState<{ loading: boolean; data: any[]; loaded: boolean }>({
    loading: false,
    data: [] as any[],
    loaded: false,
  });

  useEffect(() => {
    if (instagramProfile) {
      fetchInstagramPhotos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instagramProfile]);

  async function fetchInstagramPhotos() {
    try {
      setMediaFeed({ ...mediaFeed, loading: true });

      await server.request
        .get(`/places/employee/ig-feed/${employee.id}`)
        .then((response) => {
          server.handleSuccess(response);
          setMediaFeed({ loading: false, data: response.data, loaded: true });
        })
        .catch((error) => {
          server.handleError(error);
        });
    } catch (error) {
      setMediaFeed({ loading: false, data: [], loaded: true });
      console.error('Failed to fetch Instagram photos:', error);
    }
  }

  const getContent = () => {
    if (mediaFeed.loading) {
      return <InstagramFeedSkeleton />;
    }

    if (mediaFeed.loaded && mediaFeed.data.length === 0) {
      return (
        <div className="flex min-h-[140px] w-full items-center justify-center">
          <p className="text-fg_secondary">{_t('noInstagramPhotosAvailable')}</p>
        </div>
      );
    }

    return <InstagramFeed profile={instagramProfile} media={mediaFeed.data} withInstagramIcon />;
  };

  if (!instagramProfile) {
    return null;
  }

  if (withCard) {
    return <Card className={classnames('mb-4', className)}>{getContent()}</Card>;
  }

  return getContent();
};
